import forEach from '../utilities/forEach';
import dataLayerPush from '../utilities/dataLayerPush';
import { post } from '../utilities/fetch';
import getRecaptchaResponse from '../utilities/getRecaptchaResponse';
import { showLoading, hideLoading } from './book-taxi-limo';
import IPaymentOrderInfo from './Interface/IPaymentorderInfo';
import renderRecaptcha from '../utilities/renderRecaptcha';
import { IGiftcardResult } from '../giftcard-purchase/Interface/IGiftcardResult';
import IHashCalculatorResult from '../giftcard-purchase/Interface/IHashCalculatorResult';

var calculatedhash = '';
var timestamp = '';
var calculatedhash = '';
var timestampCalculated = '';

const PAYMENT_FORM_SELECTOR = '[data-payment-form]';
const API_ATTRIBUTE = 'data-api';
const HASH_API_ATTRIBUTE = 'hash-data-api';
const RECAPTCHA_KEY_ATTRIBUTE = 'data-google-recaptcha-key';
const OTHER_REASON_ATTRIBUTE = 'other-payment-reason';
const MERCHANT_ID_ATTRIBUTE = 'merchant-id';
const SECRET_ATTRIBUTE = 'secret-key';
const IS_PARKING_PAGE_ATTRIBUTE = 'is-parking-page';
const FIELD_DETAILED_INACTIVE = 'field-detail--inactive';
const ERROR_MESSAGE_ACTIVE_CLASSNAME = 'error-message--active';
const FIELD_DETAILED_DISPLAYNONE = 'field-detail-invisible';
const INPUT_ERROR_CLASSNAME = 'input--error';

interface IApiResult {
	LicensePlate: string;
	EntryDate: string;
	ErrorCode: string | null;
}

export default function main() {
	const forms = document.querySelectorAll(PAYMENT_FORM_SELECTOR);
	forEach(forms, (form: HTMLFormElement) => {
		form.addEventListener('submit', onSubmit);
		const isParkingPage = form.getAttribute(IS_PARKING_PAGE_ATTRIBUTE);
		const CompanynameElement = form.querySelector<HTMLInputElement>('[name=pf-companyname]')!;
		const CompanynumberElement = form.querySelector<HTMLInputElement>('[name=pf-companynumber]')!;
		const CompanyemailElement = form.querySelector<HTMLInputElement>('[name=pf-companyemail]')!;
		const CompanyphonenumberElement = form.querySelector<HTMLInputElement>('[name=pf-companyphonenumber]')!;
		const InvoiceElement = form.querySelector<HTMLInputElement>('[name=pf-invoice]')!;
		const PaymentReasonElement = form.querySelector<HTMLInputElement>('[name=pf-paymentreason]')!;
		const AmountElement = form.querySelector<HTMLInputElement>('[name=pf-amount]')!;
		const AccountElement = form.querySelector<HTMLInputElement>('[name=pf-accountnumber]')!;
		const inputs = [CompanynameElement, CompanyemailElement, CompanyphonenumberElement, InvoiceElement, AmountElement];
		if (isParkingPage == 'true') {
			inputs.push(AccountElement);
		} else {
			inputs.push(CompanynumberElement);
		}
		inputs.forEach((input) => {
			input.addEventListener('change', onChange);
		});
		PaymentReasonElement.addEventListener('change', checkpaymentreason);
		const recaptchaKey = form.getAttribute(RECAPTCHA_KEY_ATTRIBUTE);
		if (recaptchaKey) {
			const div = document.createElement('div');
			div.id = 'recaptcha-container';
			form.appendChild(div);

			setTimeout(() => {
				renderRecaptcha(recaptchaKey, div);
			}, 2000);
		}
	});
}

async function onChange(e: MouseEvent) {
	e.preventDefault();
	const input = e.currentTarget as HTMLInputElement;
	ToggleMessagesForEachElement(input);
}

async function onSubmit(e: MouseEvent) {
	e.preventDefault();

	const form = e.currentTarget as HTMLFormElement;
	const button = form.querySelector<HTMLButtonElement>('button');
	const api = form.getAttribute(API_ATTRIBUTE);
	const otherReason = form.getAttribute(OTHER_REASON_ATTRIBUTE);
	const isParkingPage = form.getAttribute(IS_PARKING_PAGE_ATTRIBUTE);
	const merchantID = form.getAttribute(MERCHANT_ID_ATTRIBUTE);
	const secretId = form.getAttribute(SECRET_ATTRIBUTE);
	const hashApi = form.getAttribute(HASH_API_ATTRIBUTE);
	timestampCalculated = await getTimestamp();
	const CompanynameElement = form.querySelector<HTMLInputElement>('[name=pf-companyname]')!;
	const CompanynumberElement = form.querySelector<HTMLInputElement>('[name=pf-companynumber]')!;
	const CompanyemailElement = form.querySelector<HTMLInputElement>('[name=pf-companyemail]')!;
	const CompanyphonenumberElement = form.querySelector<HTMLInputElement>('[name=pf-companyphonenumber]')!;
	const InvoiceElement = form.querySelector<HTMLInputElement>('[name=pf-invoice]')!;
	const PaymentReasonElement = form.querySelector<HTMLInputElement>('[name=pf-paymentreason]')!;
	const otherReasonInputElement = form.querySelector<HTMLInputElement>('[name=pf-paymentotherreason]')!;
	const AmountElement = form.querySelector<HTMLInputElement>('[name=pf-amount]')!;
	const TimeStampElement = form.querySelector<HTMLInputElement>('[name=TIMESTAMP]')!;
	const OrderIdElement = form.querySelector<HTMLInputElement>('[name=ORDER_ID]')!;
	const PfAmountElement = form.querySelector<HTMLInputElement>('[name=AMOUNT]')!;
	const ShahashElement = form.querySelector<HTMLInputElement>('[name=SHA1HASH]')!;
	const CUST_NUMElement = form.querySelector<HTMLInputElement>('[name=CUST_NUM]')!;
	const PROD_IDElement = form.querySelector<HTMLInputElement>('[name=PROD_ID]')!;
	const COMMENT1Element = form.querySelector<HTMLInputElement>('[name=COMMENT1]')!;
	const COMMENT2Element = form.querySelector<HTMLInputElement>('[name=COMMENT2]')!;
	const VAR_REFElement = form.querySelector<HTMLInputElement>('[name=VAR_REF]')!;
	const phoneNumberElement = form.querySelector<HTMLInputElement>('[name=HPP_CUSTOMER_PHONENUMBER_MOBILE]')!;
	const AccountElement = form.querySelector<HTMLInputElement>('[name=pf-accountnumber]')!;
	const inputs = [CompanynameElement, CompanyemailElement, CompanyphonenumberElement, InvoiceElement, PaymentReasonElement, AmountElement];
	if (PaymentReasonElement && PaymentReasonElement.value == otherReason) {
		inputs.push(otherReasonInputElement);
	}
	if (isParkingPage == 'true') {
		inputs.push(AccountElement);
	} else {
		inputs.push(CompanynumberElement);
	}
	try {
		if (button) {
			showLoading(button);
		}
		if (allInputsAreValid(inputs)) {
			const recaptchaResponse = await getRecaptchaResponse();
			if (recaptchaResponse) {
				dataLayerPush({
					event: 'Tp Payment forms Submit'
				});
				var paymentreason = '';
				var companynumber = '';
				if (PaymentReasonElement && PaymentReasonElement.value == otherReason) {
					if (otherReasonInputElement) {
						paymentreason = otherReasonInputElement.value;
					}
				} else {
					paymentreason = PaymentReasonElement.value;
				}
				if (isParkingPage == 'true' && AccountElement) {
					companynumber = AccountElement.value;
				} else if (isParkingPage == 'false' && CompanynumberElement) {
					companynumber = CompanynumberElement.value;
				}

				var paymentamount = (parseFloat(AmountElement.value) * 100).toString();

				if (paymentamount.indexOf('.') != -1) {
					paymentamount = (parseFloat(AmountElement.value) * 100).toFixed();
				}

				const body: IPaymentOrderInfo = {
					CompanyName: CompanynameElement.value,
					CompanyNumber: companynumber,
					CompanyEmailAddress: CompanyemailElement.value,
					InvoiceNumbers: InvoiceElement.value,
					PaymentFor: paymentreason,
					Amount: paymentamount
				};
				try {
					if (api) {
						const result = (await postTpPaymentsOrder(api, body)) as IGiftcardResult;
						if (result) {
							if (result.status == 'success' && result.orderID != '') {
								if (hashApi) {
									const OPTIONS = {
										timeStamp: timestampCalculated.toString(),
										orderID: result.orderID,
										orderValue: body.Amount,
										merchantID: merchantID,
										secret: secretId
									};
									const response = await post(hashApi, OPTIONS);
									const json: IHashCalculatorResult = await response.json();
									if (json.success == true) {
										calculatedhash = json.hash;
										if (ShahashElement && PfAmountElement && OrderIdElement && TimeStampElement) {
											ShahashElement.value = calculatedhash;
											PfAmountElement.value = body.Amount;
											OrderIdElement.value = result.orderID;
											PROD_IDElement.value = InvoiceElement.value;
											if (isParkingPage == 'true') {
												CUST_NUMElement.value = AccountElement.value;
											} else {
												CUST_NUMElement.value = CompanynumberElement.value;
											}
											COMMENT1Element.value = CompanyemailElement.value;
											COMMENT2Element.value = CompanyphonenumberElement.value;
											VAR_REFElement.value = CompanynameElement.value;
											TimeStampElement.value = timestampCalculated;
											if (CompanyphonenumberElement && phoneNumberElement) {
												phoneNumberElement.value = CompanyphonenumberElement.value;
											}
											form.submit();
										}
									}
								}
							} else {
								return false;
							}
						}
					}
				} catch (e) {
					return false;
				}
			}
		} else {
			showErrorMessages(inputs);
		}
		dataLayerPush({
			event: 'Payments forms reveal'
		});
	} catch (c) {
		console.log(`Error trying to request: ${c}`);
	} finally {
		if (button) {
			hideLoading(button);
		}
	}
}

function allInputsAreValid(inputs: HTMLInputElement[]) {
	return inputs.every((input: HTMLInputElement) => {
		return input.checkValidity();
	});
}

function showErrorMessages(inputs) {
	inputs.forEach((input) => {
		ToggleMessagesForEachElement(input);
	});
}

function ToggleMessagesForEachElement(input: HTMLInputElement) {
	const ariaDescribedBy = input.getAttribute('id');
	if (ariaDescribedBy) {
		const fieldDetail = document.getElementById(ariaDescribedBy + '-fieldDetail');
		const errorMessage = document.getElementById(ariaDescribedBy + '-errormessage');
		if (errorMessage && fieldDetail) {
			if (input.checkValidity()) {
				input.setAttribute('aria-describedby', ariaDescribedBy + '-fieldDetail');
				removeErrorClassnames(input, errorMessage, fieldDetail);
			} else {
				input.setAttribute('aria-describedby', ariaDescribedBy + '-errormessage');
				addErrorClassnames(input, errorMessage, fieldDetail);
			}
		}
	}
}

function addErrorClassnames(input: HTMLInputElement, errorMessage: HTMLElement, fieldDetail: HTMLElement) {
	input.classList.add(INPUT_ERROR_CLASSNAME);
	if (errorMessage) {
		errorMessage.classList.add(ERROR_MESSAGE_ACTIVE_CLASSNAME);
		fieldDetail.classList.add(FIELD_DETAILED_INACTIVE);
		fieldDetail.classList.add(FIELD_DETAILED_DISPLAYNONE);
	}
}

function removeErrorClassnames(input: HTMLInputElement, errorMessage: HTMLElement, fieldDetail: HTMLElement) {
	input.classList.remove(INPUT_ERROR_CLASSNAME);
	if (errorMessage) {
		errorMessage.classList.remove(ERROR_MESSAGE_ACTIVE_CLASSNAME);
		if (!fieldDetail.classList.contains(FIELD_DETAILED_INACTIVE)) {
			fieldDetail.classList.add(FIELD_DETAILED_INACTIVE);
		}
		if (fieldDetail.classList.contains(FIELD_DETAILED_DISPLAYNONE)) {
			fieldDetail.classList.remove(FIELD_DETAILED_DISPLAYNONE);
		}
	}
}

async function postTpPaymentsOrder(ApiUrl: string, body: IPaymentOrderInfo): Promise<IGiftcardResult> {
	const response = await post(ApiUrl, body);
	const jsonResponse = await response.json();
	return jsonResponse as IGiftcardResult;
}

async function checkpaymentreason(e: MouseEvent) {
	e.preventDefault();
	const form = document.querySelector(PAYMENT_FORM_SELECTOR);
	var otherReason = '';
	if (form) {
		otherReason = form.getAttribute(OTHER_REASON_ATTRIBUTE) as string;
	}
	const otherReasonDivElement = document.getElementById('payment-form-otherpaymentreason');
	const otherReasonInputElement = document.getElementById('pf-paymentotherreason');
	const paymentReasonInputElement = document.getElementById('pf-paymentreason') as HTMLInputElement;
	ToggleMessagesForEachElement(paymentReasonInputElement);
	if (paymentReasonInputElement && paymentReasonInputElement.value == otherReason && otherReasonDivElement) {
		if (otherReasonDivElement.classList.contains('dis-none')) {
			otherReasonDivElement.classList.remove('dis-none');
			const input = otherReasonInputElement as HTMLInputElement;
			input.addEventListener('change', onChange);
		}
	} else {
		if (otherReasonDivElement && !otherReasonDivElement.classList.contains('dis-none')) {
			otherReasonDivElement.classList.add('dis-none');
		}
	}
}

async function getTimestamp() {
	var date = new Date();
	timestamp =
		date.getFullYear().toString() +
		timeStampPad(date.getMonth() + 1) +
		timeStampPad(date.getDate()) +
		timeStampPad(date.getHours()) +
		timeStampPad(date.getMinutes()) +
		timeStampPad(date.getSeconds());
	return timestamp.toString();
}
function timeStampPad(n) {
	return n < 10 ? '0' + n : n;
}

main();
